import html2pdf from 'html2pdf.js';

export class CvDownloader {
    private cvContent: HTMLElement;

    constructor(cvContentElement: HTMLElement) {
        this.cvContent = cvContentElement;
    }

    /**
     * Download CV as PDF using html2pdf.js
     */
    async downloadPdf(): Promise<void> {
        const opt = {
            margin: [10, 10, 10, 10],
            filename: 'CV_Gareth_Brown_Software_Engineer.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { 
                scale: 2,
                useCORS: true,
                letterRendering: true
            },
            jsPDF: { 
                unit: 'mm', 
                format: 'a4', 
                orientation: 'portrait' 
            },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        try {
            await html2pdf().set(opt).from(this.cvContent).save();
        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Failed to generate PDF. Please try again.');
        }
    }
}
